import React, { useState, memo } from "react";
import IconButton from "@mui/material/IconButton";
import { Tooltip } from "@mui/material";
import ImportExportIcon from '@mui/icons-material/ImportExport';
import moment from "moment-jalaali";
import ExcelJS from "exceljs";
import Api from "../../utils/api";
import { Loading } from "../../components";

const FinanceGroupExcelDownload = ({ object }) => {
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const params = { ...object, excel_export: 1 };
            const response = await new Api().get("/finance/group", params);
            const items = Array.isArray(response) ? response : [];
            if (items.length === 0) {
                setLoading(false);
                return;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("FinanceGroup");

            worksheet.columns = [
                { header: "شناسه کاربر", key: "id", width: 15 },
                { header: "کاربر", key: "user", width: 25 },
                { header: "بدهکار", key: "debtor", width: 20 },
                { header: "بستانکار", key: "creditor", width: 20 },
                { header: "مبلغ کل", key: "total", width: 20 },
            ];

            items.forEach((entity) => {
                worksheet.addRow({
                    id: entity.user?.id ?? '-',
                    user: entity.user ? `${entity.user.name} ${entity.user.family}` : '-',
                    debtor: entity.debtor ?? '-',
                    creditor: entity.creditor ?? '-',
                    total: entity.total ?? '-',
                });
            });

            worksheet.getRow(1).eachCell((cell) => {
                cell.font = { bold: true, size: 14 };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFCCEEFF' } };
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            });

            worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                if (rowNumber > 1) {
                    row.eachCell((cell) => {
                        cell.font = { size: 12 };
                        cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    });
                }
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `finance_group_${moment().unix()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Error exporting finance group:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Tooltip title="خروجی اکسل">
                <IconButton onClick={fetchData} disabled={loading}>
                    <ImportExportIcon />
                </IconButton>
            </Tooltip>
            {loading && <Loading />}
        </>
    );
};

export default memo(FinanceGroupExcelDownload);
